import { Container } from "../../components";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { generalIcons } from "../../utils/constants";
import { Accordion } from "../../components/Accordion";
import "react-bootstrap-accordion/dist/index.css";

export default function FreqAskQuestions() {
  const [activeAccordion, setActiveAccordion] = useState(0);

  const toggleAccordion = (index) => {
    setActiveAccordion((prev) => (prev === index ? null : index));
  };
  return (
    <div className="relative h-auto pb-16 lg:pb-[100px]">
      <Container>
        <div className="flex items-center">
          <Link
            to={"/"}
            className="flex items-center -tracking-08 w-fit text-xs md:text-xsm font-medium text-dim"
          >
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-lightGray/[0.06] p-1 mr-4 *:w-full *:h-full">
              {generalIcons.backArrow}
            </div>
            <span className="opacity-[50%] mr-1">Overview / </span>
          </Link>
          <span className="text-xs md:text-xsm">FAQs</span>
        </div>

        <div className="relative mt-11 text-center">
          <h1 className="heading text-textcolor font-bold lg:-tracking-37 mb-12">
            Frequently Asked Questions
          </h1>

          {/* <div className="faq w-full mt-[60px] max-w-[1190px] mx-auto space-y-6">
            <div className="text-left p-5 laptop:p-[30px] rounded-2xl bg-[#121212] drop-shadow-lg">
              <h2 className="text-base lg:text-[24px] leading-7 -tracking-07 font-semibold mb-3 lg:mb-4">
                Who is eligible for Vanar Launchpool?
              </h2>
              <p className="text-xsm lg:text-sm font-normal -tracking-08 text-dim/[.74]">
                Only users who have completed the individual KYC L1 requirement
                are eligible. Please note that enterprises are not eligible for
                the event. You can 
                <a href="/#/" target="_blank" rel="noopener noreferrer">
                  click here
                </a>
                 to complete the verification.
              </p>
            </div>
          </div> */}
          <section className="pb-[120px] relative faqGradientEffect">
            <div className="space-y-[15px]">
              <Accordion
                show
                index={0}
                isActive={activeAccordion === 0}
                toggleAccordion={toggleAccordion}
                count="01"
                question="What is Vanar Staking ?"
                answer="Vanar Staking is a Delegated Proof of Stake platform where users can stake $VANRY tokens to earn rewards and enhance network security."
              />
              <Accordion
                index={1}
                isActive={activeAccordion === 1}
                toggleAccordion={toggleAccordion}
                count="02"
                question="How do I stake my $VANRY tokens?"
                answer="To stake $VANRY tokens, connect your wallet to the Vanar Staking platform, choose a desired Validator and follow the instructions."
              />
              <Accordion
                index={2}
                isActive={activeAccordion === 2}
                toggleAccordion={toggleAccordion}
                count="03"
                question="Is there a minimum amount required to stake?"
                answer="There is no minimum staking amount; users can stake any amount of $VANRY tokens."
              />
              <Accordion
                index={3}
                isActive={activeAccordion === 3}
                toggleAccordion={toggleAccordion}
                count="04"
                question="When are staking rewards distributed?"
                answer="Rewards are accrued continuously and can be claimed at any time by the user."
              />
              <Accordion
                index={4}
                isActive={activeAccordion === 4}
                toggleAccordion={toggleAccordion}
                count="05"
                question="Is there a lockup or cooldown period for staking and unstaking?"
                answer="There is no lockup period when staking tokens, meaning users can stake or unstake their tokens at any time. However, after initiating an unstake, there is a 21-day cooldown period before the staked tokens become available to be claimed."
              />
              <Accordion
                index={5}
                isActive={activeAccordion === 5}
                toggleAccordion={toggleAccordion}
                count="06"
                question=" What is Commission?"
                answer="Commission is a fee that a Validator charges on the rewards earned by Delegators (stakers) and is meant to cover the operational costs.
                Example: If a user stakes 1,000 VANRY with an APY of 20% and a Commission of 10%, the user will earn 200 VANRY as a reward. However, 20 VANRY will go to the Validator due to the 10% commission, leaving the user with 180 VANRY as their final reward."
              />
              <Accordion
                index={6}
                isActive={activeAccordion === 6}
                toggleAccordion={toggleAccordion}
                count="07"
                question="Is there any penalty or fee for unstaking tokens from Validators?"
                answer="There are no penalties or fees for staking or unstaking $VANRY tokens, but there are blockchain transactions fees!"
              />
              <Accordion
                index={7}
                isActive={activeAccordion === 7}
                toggleAccordion={toggleAccordion}
                count="08"
                question="Can I stake additional tokens after my initial stake?"
                answer="Yes, users can add more $VANRY tokens to their stake at any time."
              />
              <Accordion
                index={8}
                isActive={activeAccordion === 8}
                toggleAccordion={toggleAccordion}
                count="09"
                question="What happens if I unstake my tokens before 24 hours?"
                answer="Rewards are realized after 24 hours, however, the calculations are done every second which means, users will earn the rewards even if they unstake before the 24 hours are complete."
              />
              <Accordion
                index={9}
                isActive={activeAccordion === 9}
                toggleAccordion={toggleAccordion}
                count="10"
                question="Is there a maximum limit to how much I can stake?"
                answer="There is no maximum staking limit; users can stake as many $VANRY tokens as they wish."
              />
              <Accordion
                index={10}
                isActive={activeAccordion === 10}
                toggleAccordion={toggleAccordion}
                count="11"
                question="How does staking contribute to network security?"
                answer="By staking $VANRY tokens, users delegate their voting power to Validators, who are responsible for securing the network and validating transactions."
              />
              <Accordion
                index={11}
                isActive={activeAccordion === 11}
                toggleAccordion={toggleAccordion}
                count="12"
                question="Can I choose which validator to delegate my stake to?"
                answer="Yes. All available and active Validators are listed in the Validators section on the website."
              />
              <Accordion
                index={12}
                isActive={activeAccordion === 12}
                toggleAccordion={toggleAccordion}
                count="13"
                question="What wallet can I use to connect to the Vanar Staking platform?"
                answer="Wallets supported are: MetaMask, Wallet Connect and Coinbase Wallet."
              />
              <Accordion
                index={13}
                isActive={activeAccordion === 13}
                toggleAccordion={toggleAccordion}
                count="14"
                question="Can I claim my rewards before the cooldown period ends for unstaking?"
                answer="Yes, staking rewards can be claimed at any time, even if your unstaked tokens are still in the 21-day cooldown period."
              />
              <Accordion
                index={14}
                isActive={activeAccordion === 14}
                toggleAccordion={toggleAccordion}
                count="15"
                question="Is there a difference in rewards based on the validator I delegate to?"
                answer="Rewards are distributed proportionally based on your staked amount and the validator's commission rate, which may vary slightly between validators."
              />
              <Accordion
                index={15}
                isActive={activeAccordion === 15}
                toggleAccordion={toggleAccordion}
                count="16"
                question="Can I re-stake my rewards to compound them?"
                answer="Yes, you can claim your rewards and re-stake them to increase your overall staking amount and maximize earnings."
              />
              <Accordion
                index={16}
                isActive={activeAccordion === 16}
                toggleAccordion={toggleAccordion}
                count="17"
                question="What happens to my rewards if I unstake all my tokens?"
                answer="Any unclaimed rewards will remain available in your account and can be claimed separately, even after you have unstaked all your tokens."
              />
            </div>
          </section>
        </div>
      </Container>
    </div>
  );
}
